import { render, staticRenderFns } from "./CollectTickets.vue?vue&type=template&id=09998bb3&scoped=true&"
import script from "./CollectTickets.vue?vue&type=script&lang=ts&"
export * from "./CollectTickets.vue?vue&type=script&lang=ts&"
import style0 from "./CollectTickets.vue?vue&type=style&index=0&id=09998bb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09998bb3",
  null
  
)

export default component.exports